import { PhoneViewModel, CreatePersonPhoneCommand, UpdatePersonPhoneCommand } from '../../models/Entities/Person/Phone/PhoneModels';
import { ErrorType } from '../../models/HttpError';

export const PERSON_PHONE_GETALL_REQUEST = 'PERSON_PHONE_GETALL_REQUEST';
export const PERSON_PHONE_GETALL_SUCCESS = 'PERSON_PHONE_GETALL_SUCCESS';
export const PERSON_PHONE_GETALL_FAILURE = 'PERSON_PHONE_GETALL_FAILURE';

export interface PersonPhoneGetAllRequestAction {
    type: typeof PERSON_PHONE_GETALL_REQUEST;
    personId: number;
}

export interface PersonPhoneGetAllSuccessAction {
    type: typeof PERSON_PHONE_GETALL_SUCCESS;
    personId: number;
    payload: PhoneViewModel[];
}

export interface PersonPhoneGetAllFailureAction {
    type: typeof PERSON_PHONE_GETALL_FAILURE;
    error: ErrorType;
}

export const PERSON_PHONE_GETBYID_REQUEST = 'PERSON_PHONE_GETBYID_REQUEST';
export const PERSON_PHONE_GETBYID_SUCCESS = 'PERSON_PHONE_GETBYID_SUCCESS';
export const PERSON_PHONE_GETBYID_FAILURE = 'PERSON_PHONE_GETBYID_FAILURE';

export interface PersonPhoneGetByIdRequestAction {
    type: typeof PERSON_PHONE_GETBYID_REQUEST;
    id: number;
}

export interface PersonPhoneGetByIdSuccessAction {
    type: typeof PERSON_PHONE_GETBYID_SUCCESS;
    payload: PhoneViewModel;
}

export interface PersonPhoneGetByIdFailureAction {
    type: typeof PERSON_PHONE_GETBYID_FAILURE;
    error: ErrorType;
}

export const PERSON_PHONE_CREATE_REQUEST = 'PERSON_PHONE_CREATE_REQUEST';
export const PERSON_PHONE_CREATE_SUCCESS = 'PERSON_PHONE_CREATE_SUCCESS';
export const PERSON_PHONE_CREATE_FAILURE = 'PERSON_PHONE_CREATE_FAILURE';

export interface PersonPhoneCreateRequestAction {
    type: typeof PERSON_PHONE_CREATE_REQUEST;
    payload: CreatePersonPhoneCommand;
}

export interface PersonPhoneCreateSuccessAction {
    type: typeof PERSON_PHONE_CREATE_SUCCESS;
    payload: PhoneViewModel;
}

export interface PersonPhoneCreateFailureAction {
    type: typeof PERSON_PHONE_CREATE_FAILURE;
    error: ErrorType;
}

export const PERSON_PHONE_UPDATE_REQUEST = 'PERSON_PHONE_UPDATE_REQUEST';
export const PERSON_PHONE_UPDATE_SUCCESS = 'PERSON_PHONE_UPDATE_SUCCESS';
export const PERSON_PHONE_UPDATE_FAILURE = 'PERSON_PHONE_UPDATE_FAILURE';

export interface PersonPhoneUpdateRequestAction {
    type: typeof PERSON_PHONE_UPDATE_REQUEST;
    payload: UpdatePersonPhoneCommand;
}

export interface PersonPhoneUpdateSuccessAction {
    type: typeof PERSON_PHONE_UPDATE_SUCCESS;
    payload: PhoneViewModel;
}

export interface PersonPhoneUpdateFailureAction {
    type: typeof PERSON_PHONE_UPDATE_FAILURE;
    id: number;
    error: ErrorType;
}

export const PERSON_PHONE_DELETE_REQUEST = 'PERSON_PHONE_DELETE_REQUEST';
export const PERSON_PHONE_DELETE_SUCCESS = 'PERSON_PHONE_DELETE_SUCCESS';
export const PERSON_PHONE_DELETE_FAILURE = 'PERSON_PHONE_DELETE_FAILURE';

export interface PersonPhoneDeleteRequestAction {
    type: typeof PERSON_PHONE_DELETE_REQUEST;
    id: number;
}

export interface PersonPhoneDeleteSuccessAction {
    type: typeof PERSON_PHONE_DELETE_SUCCESS;
    id: number;
}

export interface PersonPhoneDeleteFailureAction {
    type: typeof PERSON_PHONE_DELETE_FAILURE;
    id: number;
    error: ErrorType;
}
